module.exports = __webpack_public_path__ + "res/ic_refresh.33b93d9f9c65c90b0096448f4873b185.png";